import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const stockCategoryService = {
  async getStockCategories(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/stock-category", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveStockCategories() {
    try {
      const response = await apiClient.get("/stock-category/active");
      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      return {
        items: toArray(dataRoot?.data || dataRoot?.items || dataRoot),
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getStockCategoryById(id) {
    if (!id) throw new Error("Stock Category ID is required");

    try {
      const response = await apiClient.get(`/stock-category/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createStockCategory(data) {
    try {
      const response = await apiClient.post("/stock-category", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateStockCategory(id, data) {
    if (!id) throw new Error("Stock Category ID is required");

    try {
      const response = await apiClient.patch(`/stock-category/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteStockCategory(id) {
    if (!id) throw new Error("Stock Category ID is required");

    try {
      const response = await apiClient.delete(`/stock-category/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default stockCategoryService;
